const actionTypeIdentifier = "45D0045F-A1C2-4B97-8A16-B10170E06FF9";

export const setOrderHistoryLogsLoading = `SET-ORDER-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getOrderHistoryLogs = `GET-ORDER-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setOrderHistoryPageSize = `SET-ORDER-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetOrderHistory = `RESET-ORDER-HISTORY-${actionTypeIdentifier}`;
export const setOrderHistoryColSearchStr = `SET-ORDER-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
